import useLocationCx from 'pages/Checkout/components/Delivery/hooks/useLocationCx.hook';
import { useCallback, useMemo, useState } from 'react';
// import { HelpersUtil } from '@mafc/common';
import { IAppState } from 'config/redux/reducers';
import { useDispatch, useSelector } from 'react-redux';
import useSessionArea from 'services/sessionArea/hooks/useSessionArea.hook';
import { isNonEmptyObject } from 'utils/helpers.util';
import { hideNotification } from 'common/Notification/redux/notification.action';
const useAddressFormOpen = () => {
  const [isAddressFormOpen, toggleAddressForm] = useState(false);
  const [sessionArea] = useSessionArea();
  const dispatch = useDispatch();
  const store = useSelector((state: IAppState) => state);
  const userData: {
    totalPoints: string;
    cardNumber: string;
    selectedAddress: any;
    addresses: any;
    countryConfig: any;
    town: string;
  } = store.userData;

  const { unSupportedFeatures = [] } = store.appConfig || {};
  const isLocationCx = useLocationCx();
  const isValidAddress = useCallback((): boolean => {
    if (isLocationCx) {
      return true;
    }
    /** Commentted below code as it doesn't exist in uat1 branch but got merged due to refactoring */

    // const isUserDefinedCityArea =
    //   unSupportedFeatures && !unSupportedFeatures.includes('USER_DEFINED_CITY');
    // const isUserDefinedFloor =
    //   unSupportedFeatures && !unSupportedFeatures.includes('USER_DEFINED_FLOOR');
    // const isQatarAddressFields =
    //   unSupportedFeatures && !unSupportedFeatures.includes('QATAR_ADDRESS_FIELDS');
    if (isNonEmptyObject(userData.selectedAddress)) {
      // const { selectedAddress } = userData;
      // const { appartment = null, town = null, makani = null } = selectedAddress;
      // if (isUserDefinedFloor && appartment) {
      //   const data = HelpersUtil.getFloorApartment(appartment, FLOOR_KEY, FLAT_KEY);
      //   if (data) {
      //     const [floor, appart] = data;
      //     if (!floor || !appart) {
      //       return false;
      //     }
      //   }
      // }
      // if ((isUserDefinedCityArea && !town) || (isQatarAddressFields && !makani)) {
      //   return false;
      // }
      // // selected address and session area should be same
      // // if this code removed then if session area is different
      // // then user is able to navigate to checkout page and nothing will be loaded
      // if (selectedAddress && sessionArea === selectedAddress.code) {
      //   return true;
      // }
    }
    if (isNonEmptyObject(userData.addresses) && isNonEmptyObject(userData.addresses.list)) {
      const {
        addresses: { list: userAddressList },
      } = userData;

      const isAddressExist = userAddressList.find(
        (userAddress: { deliveryArea: { code: string } }) =>
          userAddress.deliveryArea.code === sessionArea
      );
      if (isAddressExist) {
        return true;
      }
    }

    return false;
  }, [isLocationCx, sessionArea, unSupportedFeatures, userData]);

  const onCloseAddressForm = () => {
    toggleAddressForm(false);
  };

  const openAddressForm = () => {
    toggleAddressForm(true);
  };

  const onAddressSuccess = () => {
    toggleAddressForm(false);
    dispatch(hideNotification());
  };

  const isSelectedAddressPresent = useMemo(() => {
    return !isNonEmptyObject(userData.selectedAddress);
  }, [userData.selectedAddress]);

  return {
    isAddressFormOpen,
    onCloseAddressForm,
    isValidAddress,
    openAddressForm,
    onAddressSuccess,
    isLocationCx,
    isSelectedAddressPresent,
    selectedAddress: userData.selectedAddress,
  };
};
export default useAddressFormOpen;
